import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { MdClose, MdOutlineFileUpload } from 'react-icons/md';
import Modal from '../../components/modal';
import Input from '../../components/Input';
import { useParams } from 'react-router-dom';

const Addnotes = () => {
  const { id } = useParams();

  const [planData, setPlanData] = useState({
    title: ''
  });

  const [pdfPreview, setPdfPreview] = useState(null);
  const [loading, setLoader] = useState(false);
  const [notes, setNotes] = useState([]);

  useEffect(() => {
    fetchNotes();
  }, []);

  const fetchNotes = async () => {
    try {
      const response = await fetch(`https://quran-backend-theta.vercel.app/v1/admin/notes/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      const result = await response.json();
      if (result.success) {
        setNotes(result.notes);
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      console.error(error);
      toast.error('An error occurred while fetching notes');
    }
  };

  const isFormValid = () => {
    return planData.title && planData.file;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPlanData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type === 'application/pdf') {
      setPlanData((prev) => ({
        ...prev,
        file: file
      }));
      setPdfPreview(URL.createObjectURL(file));
    } else {
      toast.error('Please upload a PDF file');
    }
  };

  const handleClick = () => {
    document.getElementById('fileInput').click();
  };

  const handleRemovePdf = () => {
    setPlanData((prev) => ({
      ...prev,
      file: null
    }));
    setPdfPreview(null);
  };

  const bannerSubmit = async (e) => {
    e.preventDefault();
    setLoader(true);

    const formdata = new FormData();
    formdata.append('images', planData.file);

    const requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow'
    };

    try {
      const response = await fetch(
        'https://file-upload-ashen.vercel.app/api/upload',
        requestOptions
      );
      const result = await response.text();
      const data = JSON.parse(result);

      if (data?.success === true) {
        const myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        myHeaders.append('Accept', 'application/json');
        myHeaders.append('Access-Control-Allow-Origin', '*');
        myHeaders.append('Authorization', `Bearer ${localStorage.getItem('token')}`);
        const raw = JSON.stringify({
          notes: [
            {
              title: planData?.title,
              content: data?.data[0]
            }
          ]
        });

        const requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: raw,
          redirect: 'follow'
        };

        const courseResponse = await fetch(
          `https://quran-backend-theta.vercel.app/v1/admin/notes/${id}`,
          requestOptions
        );
        const courseResult = await courseResponse.text();
        const courseData = JSON.parse(courseResult);

        if (courseData?.success === false) {
          if (courseData?.message === 'Expired') {
            localStorage.clear();
            window.location.reload();
          } else {
            toast.error(courseData?.message);
          }
        } else {
          toast.success('notes added successfully!');
          fetchNotes();
          window.location.reload();
        }
      } else {
        toast.error('Error uploading PDF file');
      }
    } catch (error) {
      console.error(error);
      toast.error('An error occurred');
    } finally {
      setLoader(false);
    }
  };

  return (
    <div>
      <div className="p-5">
        <form onSubmit={bannerSubmit}>
          <div className="flex gap-5 flex-wrap">
            <div className="w-full">
              <Input
                label={'Title'}
                placeholder={'title'}
                className={'bg-gray-100 px-2 w-full'}
                name="title"
                value={planData.title}
                onChange={handleChange}
              />
            </div>

            <div
              className="w-full border-dashed border-[#9E9E9E] bg-[#F6F6F6] border-2 rounded-lg p-4 cursor-pointer"
              onClick={handleClick}
            >
              <div className="bg-[#F6F6F6] mx-auto w-14 flex justify-center items-center h-20 rounded-2xl">
                <MdOutlineFileUpload size={30} className="text-primary" />
              </div>
              <p className="text-primary font-medium mt-3 text-center">
                <span className="text-secondary">Click here</span> to upload or drop PDF
              </p>

              {pdfPreview && (
                <div className="relative w-full h-32 mt-4">
                  <iframe
                    src={pdfPreview}
                    title="PDF Preview"
                    className="w-full h-full object-cover rounded-md"
                  />
                  <button
                    type="button"
                    onClick={handleRemovePdf}
                    className="absolute top-0 right-0 bg-red-500 text-white p-2 rounded-full"
                  >
                    <MdClose size={20} />
                  </button>
                </div>
              )}
              <input
                id="fileInput"
                type="file"
                style={{ display: 'none' }}
                onChange={handleFileChange}
                accept="application/pdf"
              />
            </div>
          </div>

          {loading ? (
            <button
              disabled
              type="button"
              className="bg-primary w-full text-center mt-3 py-2.5 rounded-lg text-white font-semibold cursor-pointer"
            >
              Loading...
            </button>
          ) : (
            <button
              type="submit"
              className={`w-full mt-3 bg-primary py-2.5 rounded-md text-white text-sm font-medium ${
                !isFormValid() && 'cursor-not-allowed opacity-50'
              }`}
              disabled={!isFormValid()}
            >
              Submit
            </button>
          )}
        </form>
      </div>
    </div>
  );
};

export default Addnotes;
